import { Component, type ReactNode } from "react";

/** Power BI/M365 never let one broken panel take down the whole page — this
 * is the equivalent for this app: catches a render-time crash anywhere
 * below it and shows a recoverable full-page error instead of a blank
 * screen. Does not catch errors in event handlers or async code (React's
 * boundary model never does) — those still need their own try/catch. */
export class ErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  state: { error: Error | null } = { error: null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: 48, textAlign: "center" }}>
          <h2>Something went wrong</h2>
          <p style={{ color: "var(--text-muted)" }}>
            This page hit an unexpected error. Reloading usually resolves it — if it keeps
            happening, contact your platform administrator.
          </p>
          <button className="primary-button" onClick={() => window.location.reload()}>
            Reload page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
